export default __webpack_public_path__ + "static/media/FAQ.c0f390a3.jpg";